export default __webpack_public_path__ + "static/excavadoras-40421ff446693246cf4e1752b2f31218.png";